import { render, staticRenderFns } from "./myLike.vue?vue&type=template&id=8e8ac39e&scoped=true"
import script from "./myLike.vue?vue&type=script&lang=js"
export * from "./myLike.vue?vue&type=script&lang=js"
import style0 from "./myLike.vue?vue&type=style&index=0&id=8e8ac39e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8ac39e",
  null
  
)

export default component.exports